import React from 'react';
import Button from 'components/common/Button';

export default class ListingPageSection extends React.Component{
  constructor(props) {
    super(props);

    this.state = {
      collapsed: props.expandable
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const { children, minHeight, maxHeight, expandable, color } = this.props;
    const { collapsed } = this.state;

    return (
      <div className="separator pt-5 clearfix">
        <div className="listing-page-section px-5" style={{ maxHeight: collapsed ? minHeight : expandable ? maxHeight : 'none' }}>
        { children }
        </div>
        { expandable && <Button btnStyle="transparent" onClick={this.toggle} className="float-right mt-3" style={{color}}>Show {collapsed ? 'all' : 'less'}</Button> }
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/ListingPageSection.js